import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Components
import Header from "./components/Header";
import Footer from "./components/Footer"; 

// Pages
import Home from "./pages/Home";
import Mechanics from "./pages/Mechanics/Mechanics";
import Schools from "./pages/Schools/Schools";
import Champions from "./pages/Champions/Champions";
import Qualifications from "./pages/Qualifications/Qualifications";
import Packages from "./pages/Packages/Packages";
import Facts from "./pages/Facts/Facts";


// Styles
import "./styles/style.css";

const App = () => {
  return (
    <Router>
      <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
        <Header />

        <main style={{ flex: 1 }}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/mechanics" element={<Mechanics />} />
            <Route path="/schools" element={<Schools />} />
            <Route path="/Champions" element={<Champions/>} />
            <Route path="/Qualifications" element={<Qualifications />} />
            <Route path="/Packages" element={<Packages />} />
            <Route path="/facts" element={<Facts />} />
          </Routes>
        </main>

        <Footer />
      </div>
    </Router>
  );
};

export default App;